import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { config } from '../config';

const AuthRolesContext = createContext<string[]>([]);

export function useAuthRoles() {
  return useContext(AuthRolesContext);
}

function DevRolesProvider({ children }: { children: ReactNode }) {
  const roles = useMemo(
    () =>
      (localStorage.getItem('atlas-dev-roles') || 'Atlas.Admin')
        .split(',')
        .map((r) => r.trim()),
    [],
  );
  return <AuthRolesContext.Provider value={roles}>{children}</AuthRolesContext.Provider>;
}

function EntraRolesProvider({ children }: { children: ReactNode }) {
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const roles = useMemo(() => {
    if (!isAuthenticated || !accounts[0]) return [];
    const idTokenClaims = accounts[0].idTokenClaims as { roles?: string[] } | undefined;
    return idTokenClaims?.roles ?? [];
  }, [accounts, isAuthenticated]);
  return <AuthRolesContext.Provider value={roles}>{children}</AuthRolesContext.Provider>;
}

export function AuthRolesProvider({ children }: { children: ReactNode }) {
  if (config.devAuth) {
    return <DevRolesProvider>{children}</DevRolesProvider>;
  }
  return <EntraRolesProvider>{children}</EntraRolesProvider>;
}
